import type { RiskLevel } from './domain';

export interface ReviewQueueItem {
  callId: number;
  externalCallId: string;
  timestamp: string;
  operatorName: string;
  riskLevel: RiskLevel;
  complaintLikelihood: number | null;
  overallQualityScore: number | null;
}

export type FinalStatus = 'Approved' | 'RequiresRevision' | 'Escalated';

export interface SubmitReviewRequest {
  finalStatus: FinalStatus;
  notes?: string | null;
  confirmedOutputs?: string | null;
  correctedOutputs?: string | null;
  flaggedForFollowUp: boolean;
}

export interface ReviewDto {
  id: number;
  reviewerId: number;
  reviewerName: string;
  notes: string | null;
  finalStatus: string | null;
  flaggedForFollowUp: boolean;
  createdAt: string;
}

export interface RiskOverrideRequest {
  riskLevel: RiskLevel;
}

export const FINAL_STATUS_LABELS: Record<string, string> = {
  Approved: 'تأیید',
  RequiresRevision: 'نیازمند اصلاح',
  Escalated: 'ارجاع به بالادست',
};
